module.exports = "/images/SS Wordmark-White 1.svg?05807a7046a07cb9c74511b86a9f75b3";